import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Printer, ShieldCheck, CalendarCheck } from "lucide-react";
import { company, navLinks, services, programs } from "../mock";
import { LogoMark } from "./Logo";

const Footer = () => {
  return (
    <footer className="bg-[#0A4557] text-slate-200">
      <div className="mx-auto max-w-7xl px-4 py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <LogoMark className="h-11 w-11 rounded-[13px]" />
            <div className="leading-tight">
              <div className="font-display font-bold text-white">Caregivers Alliance</div>
              <div className="text-xs tracking-[0.15em] text-[#5FD3A0] font-semibold">HOMECARE</div>
            </div>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">
            {company.mission}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {programs.map((p) => (
              <span key={p.name} className="text-xs bg-white/10 rounded-full px-3 py-1 flex items-center gap-1">
                <ShieldCheck className="h-3 w-3 text-[#5FD3A0]" /> {p.name}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="hover:text-[#5FD3A0] transition-colors">{l.label}</Link>
              </li>
            ))}
            <li>
              <a data-testid="footer-book-link" href={company.calendly} target="_blank" rel="noopener noreferrer"
                 className="inline-flex items-center gap-1.5 text-[#5FD3A0] font-semibold hover:underline">
                <CalendarCheck className="h-3.5 w-3.5" /> Book a Free Consultation
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {services.map((s) => (
              <li key={s.id}>
                <Link to="/services" className="hover:text-[#5FD3A0] transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[#5FD3A0]" /><span>{company.address}<br />{company.city}</span></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#5FD3A0]" /><a href={`tel:${company.phoneRaw}`} className="hover:text-[#5FD3A0]">{company.phone}</a></li>
            <li className="flex items-center gap-2"><Printer className="h-4 w-4 text-[#5FD3A0]" /><span>Fax {company.fax}</span></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#5FD3A0]" /><a href={`mailto:${company.email}`} className="hover:text-[#5FD3A0]">{company.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} {company.legal}. All rights reserved.</span>
          <span>Headquartered in Columbus, Ohio • Statewide DODD referral coverage • {company.hours}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
